import React from 'react';
import SimpleIndicator from '../indicators/simpleIndicator';
import Label from '../label';

/**
 * component responsible for displaying fatigue indicators  
 * @param {Object} props object with the properties sent to the component
 * @returns component rendering
 */
const FatigueIndicators = (props) => {
  const lowerRestTimeIndicator = getLowerRestTimeIndicator(props);

  return (
    <div className="fatigue-indicators">
      <div className="fatigue-indicators-row spacing" />
      <div className={`fatigue-indicators-row ${props.class}`}>
        <div className="fatigue-indicators-cell">
          <SimpleIndicator
            graphColorRange={props.graphColorRange.averageShiftTime}
            value={props.data.averageShiftTime}
            valueFormat={{ type: 'NUMBER', format: 'hh:mm', factor: '3600', factorOperator: '/' }}
          />
          <Label
            tooltip={props.language.averageShiftTimeText}
            label={props.language.averageShiftTime}
          />
        </div>
        <div className="fatigue-indicators-cell">
          <SimpleIndicator
            graphColorRange={props.graphColorRange.quantityLongRest}
            value={props.data.quantityLongRest}
            valueFormat={{ type: 'NUMBER', format: '.1f' }}
          />
          <Label
            tooltip={
              props.driverView ? 
              props.language.quantityLongRestTextDriverView :
              props.language.quantityLongRestText
            }
            label={props.language.quantityLongRest}
          />
        </div>
        <div className="fatigue-indicators-cell">
          <SimpleIndicator
            graphColorRange={props.graphColorRange.drivenTimeMidnight}
            value={props.data.drivenTimeMidnight}
            valueFormat={{ type: 'NUMBER', format: 'hh:mm', factor: '3600', factorOperator: '/' }}
          />
          <Label
            tooltip={props.language.drivenTimeMidnightText}
            label={props.language.drivenTimeMidnight}
          />
        </div>
        <div className="fatigue-indicators-cell">
          <SimpleIndicator
            graphColorRange={props.graphColorRange.drivenTimeSunRise}
            value={props.data.drivenTimeSunRise}
            valueFormat={{ type: 'NUMBER', format: 'hh:mm', factor: '3600', factorOperator: '/' }}
          />
          <Label
            tooltip={props.language.drivenTimeSunRiseText}
            label={props.language.drivenTimeSunRise}
          />
        </div>
      </div>
      <div className={`fatigue-indicators-row ${props.class}`}>
        <div className="fatigue-indicators-cell">
          <SimpleIndicator
            graphColorRange={props.graphColorRange.shiftOverThreshPercentage}
            value={props.data.shiftOverThreshPercentage}
            valueFormat={{ type: 'NUMBER', format: '.0f', sufix: '%' }}
          />
          <Label
            tooltip={props.language.shiftOverThreshPercentageText}
            label={props.language.shiftOverThreshPercentage}
          />
        </div>
        <div className="fatigue-indicators-cell">
          <SimpleIndicator
            graphColorRange={props.graphColorRange.startShiftDifferenceTime}
            value={props.data.startShiftDifferenceTime}
            valueFormat={{ type: 'NUMBER', format: 'hh:mm', factor: '3600', factorOperator: '/' }}
          />
          <Label
            tooltip={props.language.startShiftDifferenceTimeText}
            label={props.language.startShiftDifferenceTime}
          />
        </div>
        <div className="fatigue-indicators-cell">
          <SimpleIndicator
            graphColorRange={lowerRestTimeIndicator.graphColorRange}
            value={lowerRestTimeIndicator.value}
            valueFormat={lowerRestTimeIndicator.valueFormat}
          />
          <Label
            tooltip={lowerRestTimeIndicator.tooltip}
            label={lowerRestTimeIndicator.label}
          />
        </div>
        <div className="fatigue-indicators-cell" />
      </div>
      <div className="fatigue-indicators-row spacing" />
    </div>
  )
};

export default FatigueIndicators;

/**
 * gets the lowerRestTime indicator associated to the queried view (detail / driver)  
 * @param {Object} props object with the properties sent to the component
 * @returns object with the indicator data
 */
const getLowerRestTimeIndicator = (props) => {
  const lowerRestTimeIndicator = {
    graphColorRange: {},
    value: 0,
    valueFormat: { type: 'NUMBER', format: '.1f' },
    tooltip: '',
    label: ''
  }

  if (props.driverView) {
    // set values for the lowerRestTimeQuantity property in the driver view
    lowerRestTimeIndicator.graphColorRange = props.graphColorRange.lowerRestTimeQuantity;
    lowerRestTimeIndicator.value = props.data.lowerRestTimeQuantity;
    lowerRestTimeIndicator.label = props.language.lowerRestTime;
    lowerRestTimeIndicator.tooltip = props.language.lowerRestTimeQuantity;
  } else {
    // set values for the lowerRestTimeAverage property in the detail view
    lowerRestTimeIndicator.graphColorRange = props.graphColorRange.lowerRestTimeAverage;
    lowerRestTimeIndicator.value = props.data.lowerRestTimeAverage;
    lowerRestTimeIndicator.label = props.language.lowerRestTime;
    lowerRestTimeIndicator.tooltip = props.language.lowerRestTimeAverage;
  }

  return lowerRestTimeIndicator;
}


// WEBPACK FOOTER //
// ./source/client/components/common/fatigue/fatigueIndicators.jsx